module.exports = __webpack_public_path__ + "static/media/puantaj_icon.b765c164.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/puantaj_icon.png
// module id = 506
// module chunks = 0